import { Dialog } from '@mui/material';
import { useEffect } from 'react';
import { useUtil } from './hooks/useUtils';

export const PopupComponent = (props: any) => {
  const { openModal, closeModal } = useUtil();

  useEffect(() => {
    if (!props.child) {
      if (props.open) {
        openModal();
      } else {
        closeModal();
      }
      return () => {
        closeModal();
      };
    }
  }, [props.open]);
  return <Dialog {...props}>{props.children}</Dialog>;
};
